import {
  FROM_CRM,
  CRM_LOADING,
  SET_CRM_ITEMS_PER_PAGE,
  CHANGE_CURRENT_CRM_PAGE,
  SEARCH_CRM,
  FILTER_CRM_FUNCTIONS,
  FILTER_CRM_ROLES,
  FILTER_CRM_STATUS,
  FILTER_CRM_DATE,
  CRM_LOADING_ZOHO,
  PULL_DATA_FROM_CRM,
  CRM_SEND_TO_PROFILE,
} from "../actions/crmAction";

const initialState = {
  fromCrmList: [],
  fromCrmSearchText: "",
  fromCrmAppliedFunctionFilter: [],
  fromCrmAppliedRolesFilter: [],
  fromCrmAppliedStatusFilter: [],
  fromCrmAppliedDateFilter: [],
  fromCRMTotalResults: null,
  fromCRMCurrentPage: 1,
  fromCRMResultsPerPage: 10,
  fromCRMTotalPages: null,
  fromCRMPageIds: [],
  fromCRMFunctionFilter: [],
  fromCRMRolesFilter: [],
  fetchingData: true,
  fetchingZoho: false,
  sendToProfile: false,
};

const crmReducer = (state = initialState, action) => {
  switch (action.type) {
    case FROM_CRM: {
      return {
        ...state,
        fromCrmList: action.payload.result.results,
        fromCRMTotalResults: action.payload.result.total_results,
        fromCRMTotalPages: action.payload.result.total_pages,
        fromCRMPageIds: action.payload.result.page_ids,
        fromCRMFunctionFilter: action.payload.filter_data.functions,
        fromCRMRolesFilter: action.payload.filter_data.roles,
        fetchingData: false,
      };
    }
    case CHANGE_CURRENT_CRM_PAGE: {
      return {
        ...state,
        fromCRMCurrentPage: action.payload,
      };
    }
    case SET_CRM_ITEMS_PER_PAGE: {
      return {
        ...state,
        fromCRMResultsPerPage: action.payload,
      };
    }
    case SEARCH_CRM: {
      return {
        ...state,
        fromCrmSearchText: action.payload,
      };
    }
    case FILTER_CRM_FUNCTIONS: {
      return {
        ...state,
        fromCrmAppliedFunctionFilter: action.payload,
      };
    }
    case FILTER_CRM_ROLES: {
      return {
        ...state,
        fromCrmAppliedRolesFilter: action.payload,
      };
    }
    case FILTER_CRM_STATUS: {
      return {
        ...state,
        fromCrmAppliedStatusFilter: action.payload,
      };
    }
    case FILTER_CRM_DATE: {
      return {
        ...state,
        fromCrmAppliedDateFilter: action.payload,
      };
    }
    case CRM_SEND_TO_PROFILE: {
      return {
        ...state,
        sendToProfile: action.payload,
      };
    }
    case CRM_LOADING: {
      return {
        ...state,
        fetchingData: true,
      };
    }
    case CRM_LOADING_ZOHO: {
      return {
        ...state,
        fetchingZoho: !state.fetchingZoho,
      };
    }
    case PULL_DATA_FROM_CRM: {
      return {
        ...state,
        fetchingZoho: false,
      };
    }
    default:
      return state;
  }
};

export default crmReducer;
